import React from 'react';
import { useTranslate } from '@hooks';

const DocsCommonResponse = (props) => {
  const { t, tHtml } = useTranslate('docs', 'common');

  return (
    <div {...props}>
      <h6 className="text-dark-light">{t('docs:responseSummary')}</h6>
      {tHtml('response')}
    </div>
  );
};

export default React.memo(DocsCommonResponse);
